import { useWebAppGetPersonsById, WebAppPersonDto } from '@mi-front/api-v2';
import { PERSON_QUERY_STALE_TIME_MS } from '../person-constants';

/**
 * Resolves a single person by id from the React Query cache warmed by
 * `usePersonsByIds`. Cache-only (no individual GET) so parallel single-gets
 * cannot race and overwrite batch results — which previously left only one
 * person visible while batch-get had returned several.
 *
 * Returns `undefined` when there is no id or the person is not in cache yet
 * so callers can fall back to voice_label.
 */
export function usePerson(personId: string | undefined | null): WebAppPersonDto | undefined {
  const { data } = useWebAppGetPersonsById(personId ?? '', {
    query: {
      // Subscribe to cache updates from batch-get; do not fetch.
      enabled: false,
      staleTime: PERSON_QUERY_STALE_TIME_MS,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  });

  if (!personId) {
    return undefined;
  }

  return data;
}
